import GET_WS_ACTIVITIES from './getWSActivities.graphql'

export default GET_WS_ACTIVITIES
